import { createTheme } from '@mui/material/styles';
import { green, amber, blue } from '@mui/material/colors';

const theme = createTheme({
  palette: {
    // primary: {
    //   light: '#757ce8',
    //   main: '#3f50b5',
    //   dark: '#002884',
    //   contrastText: '#fff',
    // },
    primary: {
      verylight: green[200],
      light: green[400],
      main: green[700],
      dark: green[900],
      contrastText: '#fff',
    },
    secondary: {
      light: amber[100],
      main: amber[700],
      dark: amber[900],
      contrastText: '#000',
    },
    alternative: {
      light: blue[200],
      main: blue[700],
      dark: blue[900],
      contrastText: '#000',
    },
    background: {
      white: '#fff', //'#fcfcfcfa'
    },
  },
});

export default theme